export const TIMELINE_COLORS: Record<string, string> = {
  CAMPAIGN: '#000000',
  PRODUCT: '#1E43A1',
  MAGELLAN: '#1E43A1',
  'COLLECTOR / PRODUCT': '#086289',
  GIFT: '#923065',
  SET: '#502B9D',
};

export const TIMELINE_PAGE_IDS: string[] = ['page1'];

export const TIMELINE_HEADERS = {
  defaultImage: '../../../../assets/img/project-v2/recap-header.jpg',
  defaultLogo: '../../../../assets/img/project-v2/comapnny-log.png',
  defaultTitle: 'LANCÔME FRAGRANCE',
  defaultSubtitle: "L'Absolu Rouge",

  yslHeader: '../../../../assets/img/project-v2/ysl-dashboard.png',
  yslLogo: '../../../../assets/img/project-v2/ysl-icon.png',
};

export const TIMELINE_FILES = {
  pptFileName: 'TimelineSummary.pptx',
  pdfFileName: 'TimelineSummary.pdf',
};

export const PDF_CONFIG = {
  pageWidthMm: 350,
  pageHeightMm: 210,
  topMarginMm: 15,
  bottomMarginMm: 15,
};

export const NOTIFY = {
  COPY_IMAGE_SUCCESS: 'Image copied successfully.',
  COPY_IMAGE_ERROR: 'Unable to copy image. Please try again.',
  COPY_IMAGE_TITLE: 'Success',
  COPY_IMAGE_ERROR_TITLE: 'Error',

  PPT_ERROR: 'Error while generating PPT:',
};

export const IMAGE_CONSTANTS = {
  TITLE_PREFIX: 'Title',
  BASE64_PREFIX: 'data:image/png;base64,',
  TYPE: 'jpeg' as 'jpeg' | 'png' | 'webp',
};

export const CRITERIA_CONSTANTS = {
  SIMPLIFIED_1: 'CRITERIA_FORM_TIMELINE_SIMPLIFIED_1',
  SIMPLIFIED_2: 'CRITERIA_FORM_TIMELINE_SIMPLIFIED_2',
};

export const FILE_CONSTANTS = {
  MIME_PPTX: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  PDF_TYPE: 'pdf',
};

export const PDF_CONSTANTS = {
  ORIENTATION: 'landscape' as 'portrait' | 'landscape',
  DEFAULT_EXTENSION: 'PDF',
  DEFAULT_FORMAT: 'a4',
  PDF_CONTENT_ID: 'pdfContent',
  PDF_EXCLUDE_SECTION_ID: 'excludeSection',
};

export const DEFAULT_DROPDOWN_VALUES = {
  milestoneFilter: ['Chronological order', 'Timeline Order', 'Both'],
};

export const COMPONENT_NAMES = {
  recap: 'recapeComponent',
  recapInside: 'recapeComponentInside',
  MILESTONE_COMPONENT: 'milestoneComponent',
};

export const COLORS: Record<string, string> = {
  CAMPAIGN: '#000000',
  PRODUCT: '#1E43A1',
  MAGELLAN: '#1E43A1',
  'COLLECTOR / PRODUCT': '#086289',
  GIFT: '#923065',
  SET: '#502B9D',
};

export const URLS = {
  WORKSPACES: '/workspaces',
  CAMPAIGN_DRIVE_BASE: '/workspaces/campaigndrive',
  CAMPAIGN_DRIVE_GENERAL: (workspaceId: string | number) => `/workspaces/campaigndrive/${workspaceId}/general`,
  CAMPAIGN_DRIVE_DASHBOARD: '/workspaces/campaigndrive/dashboard',
  CAMPAIGN_DRIVE_DASHBOARD_ARRAY: ['/workspaces', 'campaigndrive', 'dashboard'],
  CAMPAIGN_DRIVE_ARRAY: ['/workspaces', 'campaign-drive'],
};

export const LABELS = {
  WORKSPACES: 'Workspaces',
  SETTINGS: 'Settings',
  RECAP: 'Recap',
  WORKSPACE: 'workspace',
  BRAND: 'Brand',
  CAMPAIGN: 'Campaign',
};
export const STORAGE_KEYS = {
  BRAND: 'brand',
};

export const DOC_ELE = {
  BREADCRUMB: 'breadcrumb',
};

export const STATUS = {
  UNKNOWN: 'UNKNOWN',
  NOT_AFFECTED: 'NOT_AFFECTED',
};

export const FILTER_KEYS = {
  VIDEO: 'VIDEO',
  STILL: 'STILL',
  YES: 'YES',
  NO: 'NO',
};

export const CSS_CLASSES = {
  BREADCRUMB_CAMPAIGN_DRIVE_GENERAL: 'campaign-drive-general',
  RECAP_PAGE: 'recap-page-active',
};

export const DATE_CONFIG = {
  LOCALE: 'en-GB',
  FORMAT_OPTIONS: { day: '2-digit', month: '2-digit', year: 'numeric' } as Intl.DateTimeFormatOptions,
};

export const MODAL_CONFIG = {
  LARGE_SIZE: 'lg',
};

export const RECAP = 'recap';
export const GO_TO_CAMPAIGN = 'gotoCampaign';
export const ASSET_BUNDLE = 'Asset Bundle';
